import { useEffect, useState } from "react";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Grid, Stack } from "@mui/system";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { useSelector } from "react-redux";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { selectUserToken } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";

const EditCollectionTypesModal = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [loading, setLoading] = useState(false);
  const { selectedRows } = useSelector((state: any) => state.metaEntity);
  const [error, setError] = useState("");
  const [collectionTypeName, setCollectionTypeName] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedRows?.collection_type_name)
      setCollectionTypeName(selectedRows?.collection_type_name);
  }, [selectedRows]);

  const handleInputChange = (value: any) => {
    setCollectionTypeName(value.replace(/[^a-zA-Z0-9_ ]/g, "")); // Removes special characters

    const regex = /^[a-zA-Z][a-zA-Z0-9_]*(?: [a-zA-Z0-9_]+)*[^ _]$/;
    // Check if at least 3 letters exist
    const letterCount = (value.match(/[a-zA-Z]/g) || []).length;

    if (!regex.test(value) || letterCount < 3) {
      setError(
        "Only letters, numbers, single spaces, and underscores allowed. Must start with a letter and cannot end with a space or underscore."
      );
    } else {
      setError("");
    }
  };

  // -- clicking on Save button to edit Collection Type
  const editCollectionType = async () => {
    const data = {
      collection_type_name: collectionTypeName,
    };
    try {
      setLoading(true);
      if (oauthTokenHeader && selectedRows?.shared_uid) {
        await MetaEntitiesEndPointLogic.updateMetaCollectionType(
          oauthTokenHeader,
          data,
          selectedRows?.shared_uid
        );
        await MetaEntitiesEndPointLogic.getMetaCollectionType(
          oauthTokenHeader,
          dispatch
        );
      } else {
        throw new Error(
          "User doesn't have permissions to edit collection type"
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  // -- clicking on Cancel button
  const handleCancel = () => {
    handleClose();
  };

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit Collection Type
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid size={12}>
                <TextField
                  value={collectionTypeName}
                  onChange={(e: any) => handleInputChange(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Collection Type *" // Set your label here
                  placeholder="Enter unique Collection Type Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                  required
                  error={!!error}
                  helperText={error}
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              This is a mandatory field.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleCancel} sx={{ mr: 1 }}>
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!collectionTypeName || !!error}
                onClick={editCollectionType}
                data-tracker="235"
              >
                Save changes <SaveOutlinedIcon sx={{ml:1}} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
};

export default EditCollectionTypesModal;
